import React from 'react';
import PropTypes from 'prop-types';
import { flowRight } from 'lodash';
import {
  DISCUSSION,
  QUESTION,
} from '@wix/communities-forum-client-commons/dist/src/constants/post-types';
import { EXPERIMENT_INCREASE_POST_LIST_ITEM_COUNT } from '@wix/communities-forum-client-commons/dist/src/constants/experiments';
import CreatePostCta from '../create-post-cta';
import ItemContainer from '../post-list-mobile-common/item-container';
import NoPostsFiltered from '../no-posts-filtered';
import { HorizontalSeparator } from '../separator';
import { CategoryPageFiltersBar } from '../filters-bar-mobile';
import PaginationMobile from '../pagination-mobile';
import { POSTS_PER_PAGE } from '../../constants/pagination';
import FollowCard from '../follow-card';
import PostListCard from '../card/post-list-card';
import withExperiment from '../../hoc/with-experiment';

const PostListMobileClassic = ({
  page,
  category,
  posts,
  postTypes: postTypesProp,
  entityCount,
  query,
  onPageChange,
  buildPageUrl,
  onLikeClick,
  showCreatePostAction,
  showFollowCategoryAction,
  showPinIcon,
  showLockIcon,
  showBestAnswer,
  showMoreButton,
  showViewCount,
  showFilters,
  hasActiveFilter,
  showMemberPosts,
  customCtaLabel,
  isPostCountIncreaseEnabled,
}) => {
  let postTypes;
  // @TODO update POSTS_PER_PAGE constant to 30, when experiment is merged
  const showPerPage = isPostCountIncreaseEnabled ? 30 : POSTS_PER_PAGE;

  if (showCreatePostAction) {
    postTypes = postTypesProp;
  }

  return (
    <div>
      {showCreatePostAction && (
        <React.Fragment>
          <ItemContainer>
            <CreatePostCta
              categorySlug={category.slug}
              postTypes={postTypes}
              createPostCtaLabel={customCtaLabel}
            />
          </ItemContainer>
          <HorizontalSeparator />
        </React.Fragment>
      )}
      {showFilters && <CategoryPageFiltersBar />}
      {!posts.length && hasActiveFilter && <NoPostsFiltered noMemberPosts={showMemberPosts} />}
      {posts.map((post, idx) => (
        <React.Fragment>
          <ItemContainer key={post._id}>
            <PostListCard
              post={post}
              query={query}
              onLikeClick={onLikeClick}
              showContent={false}
              showPinIcon={showPinIcon}
              showLockIcon={showLockIcon}
              showBestAnswer={showBestAnswer}
              showMoreButton={showMoreButton}
              showViewCount={showViewCount}
              showRecentActivity
            />
          </ItemContainer>
          {idx < posts.length - 1 ? <HorizontalSeparator /> : null}
        </React.Fragment>
      ))}
      <PaginationMobile
        page={page}
        entityCount={entityCount}
        showPerPage={showPerPage}
        onChange={({ page }) => onPageChange(page)}
        buildPageUrl={buildPageUrl}
      />
      {(showCreatePostAction || showFollowCategoryAction) && <HorizontalSeparator />}
      {showCreatePostAction && (
        <React.Fragment>
          <ItemContainer>
            <CreatePostCta
              categorySlug={category.slug}
              postTypes={postTypes}
              createPostCtaLabel={customCtaLabel}
            />
          </ItemContainer>
        </React.Fragment>
      )}
      {showFollowCategoryAction && (
        <FollowCard withoutPaddingTop={showCreatePostAction} category={category} />
      )}
    </div>
  );
};

PostListMobileClassic.propTypes = {
  onLikeClick: PropTypes.func.isRequired,
  category: PropTypes.object,
  posts: PropTypes.array,
  location: PropTypes.object,
  query: PropTypes.string,
  showCreatePostAction: PropTypes.bool,
  showFollowCategoryAction: PropTypes.bool,
  showFilters: PropTypes.bool,
  showPinIcon: PropTypes.bool,
  showLockIcon: PropTypes.bool,
  showBestAnswer: PropTypes.bool,
  showMoreButton: PropTypes.bool,
  showViewCount: PropTypes.bool,
  hasActiveFilter: PropTypes.bool,
  uniquePostTypesInAllCategories: PropTypes.array,
  page: PropTypes.number,
  entityCount: PropTypes.number,
  onPageChange: PropTypes.func,
  buildPageUrl: PropTypes.func,
  showMemberPosts: PropTypes.bool,
  postTypes: PropTypes.arrayOf(PropTypes.oneOf([QUESTION, DISCUSSION])),
};

PostListMobileClassic.defaultProps = {
  showPinIcon: true,
  showLockIcon: true,
  showBestAnswer: true,
  showMoreButton: true,
  showViewCount: true,
};

export default flowRight(
  withExperiment({
    isPostCountIncreaseEnabled: EXPERIMENT_INCREASE_POST_LIST_ITEM_COUNT,
  }),
)(PostListMobileClassic);
